import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { TenantTemplates } from 'src/app/common/media.model';
import { Observable } from 'rxjs';
import { TemplateService } from 'src/app/shared/template.service';
import { ISortableFilter, SortDirection } from 'src/app/common/sortable-filter';
import { map, tap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'hc-tenant-template-picker',
  templateUrl: './tenant-template-picker.component.html',
  styleUrls: ['./tenant-template-picker.component.scss']
})
export class TenantTemplatePickerComponent implements OnInit {
  public selectedTemplate: TenantTemplates;

  public selectedTemplateTypeID: number; // js report long GUID

  public templatesList: Observable<Array<TenantTemplates>>;

  public loading = true;
  public unusedOnly = true;

    private logTemplateOptions(items: Array<TenantTemplates>, reason: string) {
      const simplified = (items || []).map(t => ({
        tenantTemplateTypeID: t.tenantTemplateTypeID,
        folder: (t as any).folder,
        name: (t as any).name
      }));

      // eslint-disable-next-line no-console
      console.log(`[TenantTemplatePicker] templatesList loaded (${reason}) count=${simplified.length}`, simplified);
      // eslint-disable-next-line no-console
      if (simplified.length) { console.table(simplified); }
    }

  constructor(
      public dialogRef: MatDialogRef<TenantTemplatePickerComponent>,
      private service: TemplateService,
      private cd: ChangeDetectorRef,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      this.templatesList =  Observable.create([]);
  }

  ngOnInit() {
      this.unusedOnlyChanged();
  }

  private async unusedOnlyChanged() {
      let filter = new TenantTemplatePickerFilter();
      const list$ = this.service.select(filter).pipe(
        map((items: Array<TenantTemplates>) => {
          const safeItems = items || [];
          const label = (t: any) => `${t?.folder ? (t.folder + ' + ') : ''}${t?.name || ''}`;
          return [...safeItems].sort((a, b) => label(a).localeCompare(label(b), undefined, { sensitivity: 'base' }));
        }),
        tap((items) => this.logTemplateOptions(items || [], 'select(filter) sorted')),
        tap(() => this.loading = false),
        tap(() => this.cd.detectChanges()));

      this.templatesList = list$;
      await list$.toPromise();
  }

  private async confirmSelection(selectedTemplateTypeID: number) {
      let templateListItems = await this.templatesList.toPromise();
      this.selectedTemplate = templateListItems.find(t => t.tenantTemplateTypeID === selectedTemplateTypeID);
      this.dialogRef.close(this.selectedTemplate);
  }
}

export class TenantTemplatePickerFilter implements ISortableFilter {
  sortColumn: string;
  sortDirection: SortDirection;
  page: number;
  pageSize: number;
  noCache: number;
  searchString: string;
  Attributes: any[];
}
